import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      color: '#51D497',
      background: '#FBFBFD',
      '& .MuiStepIcon-active': {
        color: 'white',
        borderRadius: '50%',
        border: '1.5px solid #51D497',
        '& .MuiStepIcon-text': {
          color: '#51D497 !important',
          fill: 'unset',
          fontWeight: '700',
          fontSize: '14px',
        },
      },
      '& .MuiStepIcon-completed': { color: '#51D497' },
      '& .Mui-disabled .MuiStepIcon-root': { color: 'lightgray' },
      '& .MuiStepper-root': {
        padding: '10px 0px 20px 0px',
        backgroundColor: '#f6f7f9 !important',
      },
      '& .MuiStepLabel-label': {
        whiteSpace: 'nowrap',
      },
      '& .MuiStepLabel-active': {
        color: '#1D3557',
      },
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);

function getSteps() {
  return ['Verify Email', 'Pay for Plan', 'Set Password'];
}

export const StepperGetStarted = ({ activeStep }) => {
  const classes = useStyles();

  const steps = getSteps();

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* <div>
        <div>
          <div>
            <Button disabled={activeStep === 0} onClick={handleBack} className={classes.backButton}>
              Back
            </Button>
            <Button variant="contained" color="primary" onClick={handleNext}>
              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
            </Button>
          </div>
        </div>
      </div> */}
    </div>
  );
};
